import { getApiClient } from '../client'
import { handleApiError } from '../utils/handleApiError'
import type {
  FamilySummary, DraftInfo, BundleInfo, ArticleInfo, PublishRequest, PublishResponse
} from '@dopomogai/types'

type SR<T> = Promise<T | import('@dopomogai/types').ApiErrorResponse>

const getFamilies = (): SR<FamilySummary[]> =>
  getApiClient().get('/content/families')
    .then(res => res.data)
    .catch(err => handleApiError(err, 'listing content families'))

const getFamilyDrafts = (family: string): SR<DraftInfo[]> =>
  getApiClient().get(`/content/families/${encodeURIComponent(family)}/drafts`)
    .then(res => res.data)
    .catch(err => handleApiError(err, `listing drafts for ${family}`))

const getFamilyBundles = (family: string): SR<BundleInfo[]> =>
  getApiClient().get(`/content/families/${encodeURIComponent(family)}/bundles`)
    .then(res => res.data)
    .catch(err => handleApiError(err, `listing bundles for ${family}`))

const getFamilyArticles = (family: string): SR<ArticleInfo[]> =>
  getApiClient().get(`/content/families/${encodeURIComponent(family)}/articles`)
    .then(res => res.data)
    .catch(err => handleApiError(err, `listing articles for ${family}`))

const publishArticle = (payload: PublishRequest): SR<PublishResponse> =>
  getApiClient().post('/content/publish', payload)
    .then(res => res.data)
    .catch(err => handleApiError(err, `publishing article '${payload.slug}'`))

export const contentEngineService = {
  getFamilies,
  getFamilyDrafts,
  getFamilyBundles,
  getFamilyArticles,
  publishArticle,
}